<template>
  <div v-show="visible" class="fast-modal-backdrop">
    <div class="fast-modal">
      <span class="h1 block"><slot name="title"></slot></span>
      <slot></slot>
      <div class="fast-modal-actions">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
$modal-spacing: 25px;
.fast-modal-backdrop {
  z-index: 1000;
  margin: 0;
  padding: 10px;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(black, 0.6);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .fast-modal {
    z-index: 1001;
    padding: $modal-spacing;
    background: white;
    max-width: 410px;
    width: 100%;
    border-radius: 5px;
    box-shadow: 0 0 1em rgba(0, 0, 0, 0.4);
    text-align: center;
    .h1 {
      font-size: 1.3em;
      font-weight: bold;
      color: #006cf1;
      margin-bottom: 1rem;
    }
    .btn {
      white-space: normal;
      &.btn-primary {
        color: white !important;
      }
    }
    .fast-modal-actions {
      margin-top: $modal-spacing;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin: 1rem -0.5rem -0.35rem;
      .btn {
        flex: 1 1 auto;
        margin: 0.35rem 0.5rem;
        &.btn-primary {
          flex-grow: 2;
          padding-left: 1.5rem;
          padding-right: 1.5rem;
        }
      }
    }
  }
}
</style>
